import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout-sidemenu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "layout-sidemenu-logo align-self-center mt-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"0.45rem"} }, "Viomba"),
    /*#__PURE__*/_createElementVNode("span", null, "Dashboard")
  ])
], -1)
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["data-route-name"]
const _hoisted_6 = { class: "layout-sidemenu-bottom" }
const _hoisted_7 = { class: "link" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "User settings", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Settings", -1)
const _hoisted_12 = { class: "flex flex-column w-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", null, "Role", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", { class: "mt-0" }, "Credentials", -1)
const _hoisted_16 = { class: "flex flex-column w-full align-self-center" }
const _hoisted_17 = { class: "p-field align-self-center w-full" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email address", -1)
const _hoisted_19 = { class: "p-input-icon-left w-full mt-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_21 = { class: "p-field align-self-center w-full mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)
const _hoisted_23 = { class: "p-input-icon-left w-full mt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", null, "Leave blank to retain your current password", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_28 = { class: "w-full flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title
          }, [
            (item.title)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(item.title), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.routes, (route) => {
              return (_openBlock(), _createElementBlock("div", {
                key: route.meta.title,
                "data-route-name": route.name
              }, [
                _createVNode(_component_router_link, {
                  to: route.meta.domicile ? route.path + '/' + (_ctx.$store.state.ui.default_domicile || _ctx.$store.state.auth.user.panel_domiciles[0].code) : route.path
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", {
                      class: _normalizeClass(route.name == _ctx.$route.name ? 'active' : '')
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass('pi pi-' + route.meta.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(route.meta.title), 1)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 8, _hoisted_5))
            }), 128))
          ]))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal.settings = true))
          }, _hoisted_10)
        ])
      ])
    ]),
    (_ctx.store.state.auth.loggedIn)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          visible: _ctx.modal.settings,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal.settings) = $event)),
          closable: true,
          breakpoints: {'1640px': '35vw', '1100px': '55vw', '640px': '100vw'},
          style: {maxWidth: '500px', width: '25vw'},
          draggable: false,
          modal: true,
          position: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_11
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Button, {
                type: "submit",
                label: "Save",
                icon: 'pi ' + (_ctx.loading.setCredentials ? 'pi-spin pi-spinner' : 'pi-check'),
                class: "align-self-center ml-auto mr-auto",
                onClick: _ctx.setCredentials
              }, null, 8, ["icon", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.roles.find(r => r.name == _ctx.$store.state.auth.user.role.name).description) + " ", 1),
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("form", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_InputText, {
                      id: "email",
                      modelValue: _ctx.credentials.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.email) = $event)),
                      type: "text",
                      class: "w-full",
                      autocomplete: "on",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_InputText, {
                      id: "password",
                      modelValue: _ctx.credentials.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.credentials.password) = $event)),
                      type: "password",
                      autocomplete: "off",
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_25
                ])
              ]),
              _hoisted_26,
              _createVNode(_component_Button, {
                type: "submit",
                label: "Notification settings",
                icon: "pi pi-bell",
                class: "align-self-start",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('openNotificationSettings')))
              }),
              _hoisted_27
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}